export const title = 'PaperWonder隐私政策';

export const content = `
<h1>隐私政策</h1>

<p><strong>更新日期：</strong>2025年8月1日<br>
<strong>生效日期：</strong>2025年9月1日</p>

<div class="note">
    <p>厦门市本色图文制作有限公司(以下简称"我们")非常重视用户隐私和个人信息保护，您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。在此特别提醒您认真阅读、充分理解我们的隐私政策(以下简称"本政策")。</p>
    <p>本政策适用于厦门市本色图文制作有限公司通过PaperWonder平台提供的产品或服务，包括:编辑图片、编辑作品、设置我的资料、联系客服、分享作品、意见反馈、订单物流、注册、登录、支付信息、网络访问日志、联合登录。</p>
    <p class="bold">您在接受PaperWonder服务之前，请务必仔细阅读本隐私政策，确保对其内容特别是字体加粗内容的含义及相应法律后果已全部知晓并充分理解。您勾选并点击"同意"即视为您接受本隐私政策;您同意本政策在您使用PaperWonder的产品和/或服务的整个过程有效。如果您对本政策有任何疑问、意见或建议，您可随时通过本政策指明的联系方式联系我们咨询并获得反馈;如果您不同意本政策，您应立即停止使用PaperWonder提供的产品和服务。</p>
</div>

<div class="section">
    <h2>一、概述</h2>
    <p>本政策将帮助您了解以下内容:</p>
    <ul>
        <li>个人信息收集使用规则</li>
        <li>我们如何共享、转让、公开披露您的个人信息</li>
        <li>我们如何保护您的个人信息</li>
        <li>您的权利</li>
        <li>我们如何处理儿童的个人信息</li>
        <li>您的个人信息如何在全球范围转移</li>
        <li>本政策如何更新</li>
        <li>如何联系我们</li>
    </ul>
    <p>我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息:权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
    <p class="bold">并请您注意，本隐私政策不适用于以下情况:</p>
    <p>为我们的产品与/或服务提供广告服务的第三方的信息收集/处理做法;</p>
    <p>我们的产品与/或服务可能会包含或链接至第三方提供的信息与/或第三方服务(包括任何第三方应用、网站、产品、服务等)，这些信息与/或服务由第三方负责运营，您使用该等信息与/或服务与我们无关。我们在此善意的提醒您，您在使用第三方信息与/或服务时，应留意和仔细阅读第三方向您展示的相关用户协议和隐私政策，并妥善保管和谨慎提供您的个人信息。本政策仅适用于我们所收集的您的个人信息，并不适用于任何第三方对您的个人信息的收集，以及任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方收集、储存和使用的您个人信息的行为在法律允许的范围内亦不承担任何责任。</p>
</div>

<div class="section">
    <h2>二、个人信息收集使用规则</h2>
    <h3>(一)向您提供产品和/或服务的核心业务功能</h3>
    <p>为实现核心业务功能，在您使用我们提供的产品和/或服务时，我们可能需要向您收集个人信息。以下将详细列出的核心业务功能及为实现该功能所需收集的个人信息，若您拒绝收集，则无法使用该服务。</p>
    <p style="font-weight: bold">我们的核心业务功能是图文作品编辑，在编辑过程中，我们需要使用设备存储读写权限以便加载和存储相关数据，需要根据陀螺仪传感器获取横竖屏状态以显示不同的编辑结果;如您需要插入图片、摄影、录音、视频，我们会需要相应的获取您设备上相册、相机、麦克风的权限，并收集您提供的相应的图像、音频和视频信息。此外，在您使用文本编辑功能的过程中，为了保障网络安全、应用维护和改进我们的服务，我们会自动收集您使用PaperWonder的详细情况，并作为有关的日志保存，包括语言设置、访问的日期和时间、编辑或修改文本的时间、设备型号、设备标识(如AndroidID、IMEI、MAC)、APP软件版本号、登录IP信息、日志信息(如操作日志、服务日志)。</p>
    <p>此外，我们将自行或与我们的关联公司、数据分析服务商或其他第三方合作，对上述信息或其他进行服务所需的信息做出的自动决策决定(如商业化信息)。有关我们与第三方共享信息的详细情况请见本隐私政策第三部分:我们如何共享、转让、公开披露您的个人信息。如果您不希望参与此类信息，请通过第九部分的联系方式要求我们作出解释，我们也将为您提供适当的救济方式。</p>
    
    <h3>(二)向您提供产品和/或服务的附加业务功能</h3>
    <p>为了向您提供更优质的产品和服务，我们可能需要收集下述信息。如果您拒绝提供下述信息，不影响您正常使用以上第(一)项所描述的核心业务功能，但我们无法向您提供某些特定功能和服务。</p>
    
    <p class="bold">1、当您登录PaperWonder账号时:</p>
    <p style="font-weight: bold">您注册成为PaperWonder产品和或服务的用户过程中，您需要向我们提供手机号码、邮箱信息或微信账号信息(微信昵称和头像、地区、性别)或QQ账号信息(QQ昵称、头像、地区和性别)或微博账号信息(微博昵称、头像、地区和性别)这些基本信息以创建用户名和密码。</p>
    <p style="font-weight: bold">您在使用第三方账户授权登录时，需要授权我们共享您在该第三方平台上登记、公布、记录的公开信息(包括昵称、头像等)，PaperWonder需要您授权从第三方获取上述信息是为了记住您作为PaperWonder用户的登录身份，以向您提供更优质的产品和/或服务。我们仅会在您的授权同意的范围内收集并使用您的个人信息。</p>
    <p style="font-weight: bold">在您使用第三方账号注册或登录后，您的第三方账号将会与PaperWonder账号进行绑定，但您可以在个人中心选择注销账号，进行取消账号绑定。</p>
    <p style="font-weight: bold">您还可选择通过摄像头或相册添加头像信息，在此情况下我们需要的获取您设备上相册、相机的权限，并收集您提供的相应的图像信息。</p>
    
    <p class="bold">2、当您发布信息时:</p>
    <p style="font-weight: bold">您注册成为PaperWonder用户并购买商品及确认收货后，后可选择发布评价，您可主动提供、上传或发布内容和信息(如发布含有您的肖像或其他个人信息的图片等)可能会泄漏您的个人敏感信息，请您谨慎对待并慎重考虑是否在使用相关服务时共享甚至公开分享相关信息。</p>
    
    <p class="bold">3、当您使用我们的产品和或服务涉及交易时:</p>
    <p style="font-weight: bold">系统将会生成您的交易订单，需要您填写订单相关的联系人姓名、地址以及手机号码，您所购买的商品或服务信息、您应支付的货款金额及支付方式等支付信息，您可能在订单上补充告知相关方的其他信息以方便交易的实现。</p>
    
    <p class="bold">4、当您使用涉及支付的功能时:</p>
    <p style="font-weight: bold">支付通过合作的第三方支付机构(微信支付、支付宝支付、苹果支付等)所提供的支付服务完成，第三方支付服务有可能使用生物识别信息用于付款验证，您在使用第三方支付服务的时候请阅读该第三方机构的隐私政策，如对于该约定不同意，请您及时停止使用该第三方支付服务。</p>
    
    <p class="bold">5、当您参加运营活动或与我们联系时:</p>
    <p style="font-weight: bold">您可以参加我们组织的运营活动，或出于申诉举报、报错、投诉等事由与我们电话联系，我们需要调取您的设备拨打电话权限以便您可以快捷拨打我们的客服电话，您可能根据要求主动提供您的姓名、联系电话、联系地址等个人信息。对于特定活动如涉及提现、奖品兑现、税务申报等目的，我们可能还需要您的身份证信息。</p>
    
    <p class="bold">6、当您反馈意见时:</p>
    <p style="font-weight: bold">当您通过意见反馈版块对我们的产品和/或服务进行意见反馈时，我们可能需要调取您的相册读取权限，以获得您需要提交的图片形式的反馈信息。</p>
    
    <p class="bold">7、关于推送:</p>
    <p>为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的;当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有关联启动。</p>
    
    <p class="bold">8、当您使用PaperWonder的功能或服务时，在某些特定使用场景下，我们可能会使用具有相应业务资质及能力的第三方服务商提供的软件服务工具包(简称"SDK")来为您提供服务，由第三方服务商收集您的必要信息。</p>
    
    <p class="bold">9、第三方SDK披露:</p>
    <p><strong>第三方SDK名称:</strong>Bugly SDK</p>
    <p><strong>第三方SDK提供方:</strong>深圳市腾讯计算机系统有限公司</p>
    <p><strong>使用目的及功能场景:</strong>排查质量问题，帮助APP提升运行质量</p>
    <p><strong>处理方式:</strong>通过去标识化、加密传输和处理的安全处理方式</p>
    <p><strong>第三方SDK隐私政策链接:</strong>https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</p>
    <p><strong>第三方SDK官网链接(可选披露):</strong>https://bugly.qq.com/v2/</p>
    <p><strong>Android端处理的个人信息类型:</strong>手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID。</p>
    <p><strong>iOS端处理的个人信息类型:</strong>设备型号、操作系统版本、操作系统内部版本号、Wi-Fi状态、cpu属性、内存剩余空间、磁盘空间、运行时手机状态(进程所占内存)、IDFV、是否越狱、地区编码。</p>
    
    <p style="color: red;">当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。</p>
    
    <p class="bold" style="color: red;">请您注意，前述部分个人信息一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇，为您的个人敏感信息，我们在提供服务中可能收集的个人敏感信息已经采取加粗的形式予以重点提示。</p>
    
    <h3>(三)商业化利用</h3>
    <p>在收集您的个人信息后，我们可能对您的个人信息进行自动化数据处理。在此情况下，我们将按照国家通用的技术标准对数据进行去标识化和/或匿名化形成用户数据库，在不侵犯您的个人隐私以及符合个人信息保护政策的前提下，我们有权对用户数据库进行挖掘、分析并予以商业化的利用。</p>
    
    <h3>(四)征得同意的例外</h3>
    <p>在以下情形中，我们可能不会事先征求您的同意而获取相关信息:</p>
    <ol>
        <li>与个人信息控制者履行法律法规规定的义务相关的;</li>
        <li>与国家安全、国防安全直接相关的;</li>
        <li>与公共安全、公共卫生、重大公共利益直接相关的;</li>
        <li>与刑事侦查、起诉、审判和判决执行等直接相关的;</li>
        <li>出于维护您或他人的生命、财产等重大合法权益但又很难及时获得您本人同意的;</li>
        <li>所收集的个人信息是您自行向社会公众公开的;</li>
        <li>根据您要求签订和履行合同所必需的;</li>
        <li>从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道、政府信息公开等渠道;</li>
        <li>用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障;</li>
        <li>出于学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的;</li>
        <li>法律法规规定的其他情形。</li>
    </ol>
</div>

<div class="section">
    <h2>三、我们如何共享、转让、公开披露您的个人信息</h2>
    <h3>(一)委托处理</h3>
    <p>本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。</p>
    <p>对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
    
    <h3>(二)共享</h3>
    <p>我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，但以下情况除外:</p>
    <ol>
        <li>在获得您的明确同意的情况下共享;</li>
        <li>根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息;</li>
        <li>与我们的附属公司共享:但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束，若附属公司如要改变个人信息的处理目的，将再次征求您的授权同意;</li>
        <li>与授权合作伙伴共享:为丰富服务内容，我们会联合或作伙伴共同向您提供服务，并依据法律法规的强制性规定与/或合作伙伴的要求收集并向合作伙伴共享您的个人信息。我们仅会出于合法、正当、必要、特定、明确的目的向合作方共享您的个人信息。如果您拒绝我们向相应的合作方共享您的信息时，则将导致您无法使用相应服务。我们的合作伙伴无权将基于本协议约定的共享情形获得的个人信息用于其他任何用途，除非您与我们的合作伙伴达成了新的约定。</li>
    </ol>
    
    <h3>(三)转让</h3>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外:</p>
    <ol>
        <li>在获取明确同意的情况下转让;</li>
        <li>在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
    </ol>
    
    <h3>(四)公开披露</h3>
    <p>我们仅会在以下情形下，公开披露您的个人信息:</p>
    <ol>
        <li>获得您明确同意后;</li>
        <li>在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</li>
    </ol>
</div>

<div class="section">
    <h2>四、我们如何保护您的个人信息</h2>
    <h3>(一)基本安全措施</h3>
    <p>我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，我们会使用加密技术确保数据的保密性，使用受信赖的保护机制防止数据遭到恶意攻击，并且部署访问控制机制，限定只有授权人员才可访问个人信息。</p>
    
    <h3>(二)我们的数据安全能力</h3>
    <p>我们已采用符合业界标准的各种安全技术和防护措施保护您的个人信息不被未经授权地访问、使用或泄漏，例如您与PaperWonder服务器交换数据时，我们采用HTTPS、SSL、AES等多种技术确保数据安全性和保密性;我们将严格遵循国内外的安全标准进行安全体系搭建，并结合前沿、主流的安全技术进行落地，防止用户的个人信息在未经授权时被访问、使用、泄露。建立了完善的安全防御体系，当我们受到外部的网络攻击、病毒感染时，能对攻击行为进行及时主动拦截。</p>
    <p>对于本应用中集成的SDK(软件开发工具包)，我们制定了严格的接入规范及审核机制，确保这些SDK(软件开发工具包)对您个人信息的访问和获取仅限于为实现其功能或服务的范围。</p>
    <p>我们已经建立健全数据安全管理体系，包括对用户信息进行分级分类、加密保存、数据访问权限划分;制定了内部数据管理制度和操作规程，从数据的获取、使用、销毁都有严格的流程要求，避免您的隐私数据被非法使用;我们将定期举办安全和隐私保护培训，提高员工的个人信息保护意识。</p>
    
    <h3>(三)数据最小化原则</h3>
    <p>我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
    
    <h3>(四)安全风险提示</h3>
    <p>互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
    
    <h3>(五)安全事件处理</h3>
    <p>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知:安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</p>
    <p>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
</div>

<div class="section">
    <h2>五、您的权利</h2>
    <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利:</p>
    
    <h3>(一)访问您的个人信息</h3>
    <p>您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问:</p>
    <p>账号信息:您可以随时登录您的个人账号，进入"我的"页面即可访问您的账号中的个人资料信息，包括头像和笔名;</p>
    <p>作品信息:您可以进入"作品编辑"和"草稿"页面随时查阅您编辑并且生效的作品信息;</p>
    <p>其他信息:如您在此访问过程中遇到操作问题的或如需获取其他前述无法获知的个人信息内容，您可通过文末提供的方式联系我们，对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们将在核实您的身份后在合理期限内向您提供，但法律法规另有规定的或本政策另有约定的除外。</p>
    
    <h3>(二)更正您的个人信息</h3>
    <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们作出更正。您可以通过第(一)项罗列的方式提出更正申请。</p>
    <p>如果您无法通过上述链接更正这些个人信息，您可通过文末提供的方式联系我们。我们将在核实您的身份后在合理期限内回复您的更正请求。</p>
    
    <h3>(三)删除您的个人信息</h3>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求:</p>
    <ol>
        <li>如果我们处理个人信息的行为违反法律法规;</li>
        <li>如果我们收集、使用您的个人信息，却未征得您的同意;</li>
        <li>如果我们处理个人信息的行为违反了与您的约定;</li>
        <li>如果您不再使用我们的产品或服务，或您注销了账号;</li>
        <li>如果我们不再为您提供产品或服务。</li>
    </ol>
    <p>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>
    <p>当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
    
    <h3>(四)改变您授权同意的范围</h3>
    <p>每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。</p>
    <p>您可以通过以下方式自行操作:您可以通过更改手机设备中的相机、定位等访问权限或更改设置选项。您也可以通过注销账号的方式，永久撤回我们继续收集您个人信息的全部授权。</p>
    <p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
    
    <h3>(五)个人信息主体注销账户</h3>
    <p>您随时可注销此前注册的账户，您可以通过以下方式自行操作:我的→设置→注销账号。</p>
    <p>在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</p>
    
    <h3>(六)约束信息系统自动决策</h3>
    <p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。</p>
    
    <h3>(七)响应您的上述请求</h3>
    <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在20个工作日内答复。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段(例如，需要开发新系统或从根本上改变现行惯例)、给他人合法权益带来风险或者非常不切实际(例如，涉及备份磁带上存放的信息)的请求，我们可能会予以拒绝。</p>
    <p>在以下情形中，我们将无法响应您的请求:</p>
    <ol>
        <li>与个人信息控制者履行法律法规规定的义务相关的;</li>
        <li>与国家安全、国防安全直接相关的;</li>
        <li>与公共安全、公共卫生、重大公共利益直接相关的;</li>
        <li>与刑事侦查、起诉、审判和执行判决等直接相关的;</li>
        <li>个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的;</li>
        <li>出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的;</li>
        <li>响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的;</li>
        <li>涉及商业秘密的。</li>
    </ol>
</div>

<div class="section">
    <h2>六、我们如何处理儿童的个人信息</h2>
    <p>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的个人信息主体账户。</p>
    <p>对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</p>
    <p>尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。</p>
    <p>如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>
</div>

<div class="section">
    <h2>七、您的个人信息如何在全球范围转移</h2>
    <p>我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。在获得您的授权同意之前，您的个人信息不会向中华人民共和国境外传输和存储。</p>
    <p>若出现在符合适用法律规定的情形下因业务需要向境外传输个人信息的情况，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措，确保您的个人信息得到在中华人民共和国境内足够同等的保护。</p>
</div>

<div class="section">
    <h2>八、本政策如何更新</h2>
    <p>我们的个人信息保护政策可能变更。</p>
    <p>未经您明确同意，我们不会削减您按照本个人信息保护政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</p>
    <p>对于重大变更，我们还会提供更为显著的通知(包括对于某些服务，我们会通过电子邮件发送通知，说明个人信息保护政策的具体变更内容)。</p>
    <p>本政策所指的重大变更包括但不限于:</p>
    <ol>
        <li>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等;</li>
        <li>我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等;</li>
        <li>个人信息共享、转让或公开披露的主要对象发生变化;</li>
        <li>您参与个人信息处理方面的权利及其行使方式发生重大变化;</li>
        <li>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时;</li>
        <li>个人信息安全影响评估报告表明存在高风险时。</li>
    </ol>
    <p>我们还会将本政策的旧版本存档，供您查阅。</p>
</div>

<div class="section">
    <h2>九、如何联系我们</h2>
    <p>如果您对本个人信息保护政策有任何疑问、意见或建议，请通过以下联系方式与我们联系:</p>
    <p>电子邮件: paperwonder@126.com</p>
    <p>我们设立了个人信息保护专职部门(或个人信息保护专员)，您可以通过以下方式与其联系:0592-5166171，一般情况下，我们将在二十个工作日内回复。</p>
    <p>如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案:网信、电信、公安及工商等监管部门进行投诉或举报，或者向有管辖权的人民法院提起诉讼。</p>
</div>
`;
